
import { useMemo } from 'react';
import { MortgageData, ValidationResult, UIState } from '@/types/calculator';

export const useCalculatorValidation = (mortgageData: MortgageData, isCalculating: boolean) => {
  const uiState: UIState = useMemo(() => {
    const downPaymentValidation: ValidationResult = {
      isValid: mortgageData.downPayment >= 0 && mortgageData.downPayment <= mortgageData.homePrice,
      message: mortgageData.downPayment > mortgageData.homePrice ? 'Down payment cannot exceed home price' : '',
      type: mortgageData.downPayment > mortgageData.homePrice ? 'error' : 'success'
    };

    const currentLoanValidation: ValidationResult = {
      isValid: true,
      message: '',
      type: 'success'
    };

    return {
      isCalculating,
      downPaymentValidation,
      isDownPaymentDisabled: false,
      minDownPaymentPercentage: mortgageData.loanType === 'va' || mortgageData.loanType === 'usda' ? 0 : (mortgageData.loanType === 'fha' ? 3.5 : 5),
      loanTypeRecommendations: ['conventional', 'fha'],
      currentLoanValidation
    };
  }, [mortgageData, isCalculating]);

  return { uiState };
};
